import { useRateLimit } from '../../hooks/useRateLimit'
import { Container, CountBadge, WarningMessage, ResetTimer } from './styles'
import { FiClock, FiAlertCircle } from 'react-icons/fi'

export function RateLimitIndicator() {
  const { rateLimit, getTimeUntilReset, getWarningMessage } = useRateLimit()

  if (rateLimit.isLoading) {
    return null
  }

  const warningMessage = getWarningMessage()
  const isLimitReached = rateLimit.remaining === 0
  const isWarning = rateLimit.remaining === 1

  return (
    <Container>
      <CountBadge $remaining={rateLimit.remaining} $limit={rateLimit.limit}>
        <span className="count">
          {rateLimit.remaining}/{rateLimit.limit}
        </span>
        <span className="label">cálculos restantes</span>
      </CountBadge>

      {warningMessage && (
        <WarningMessage $isError={isLimitReached}>
          <FiAlertCircle />
          <span>{warningMessage}</span>
        </WarningMessage>
      )}

      {rateLimit.resetAt && (isLimitReached || isWarning) && (
        <ResetTimer>
          <FiClock />
          <span>Reseta em: {getTimeUntilReset()}</span>
        </ResetTimer>
      )}
    </Container>
  )
}
